<template>
  <div>
    <div class="content">
      <div class="row align-items-center">
        <div class="col-md-6"></div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="loading">
      <loading />
    </div>
    <div class="row">
      <div class="col-md-12">
        <Titulo
          title="Lista de Associados"
          description="Gerencia sua carteira de associados à partir da lista."
        />
        <div class="row justify-content-center" v-if="loading">
          <loading />
        </div>
        <div v-else-if="lista.length > 0">
          <ListaCarteira class="mt-5" :lista="lista" />
        </div>
        <div class="col-12" v-else>
          <div
            class="border-0 py-5 d-flex justify-content-center align-items-center"
          >
            <h5>Nenhum associado encontrado. 😟</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 flex-column-reverse flex-md-row">
      <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
        <Botao
          title="Voltar"
          @click="$router.push({ name: 'Dashboard' })"
          nameClass="btn btn-outline-secondary btn-lg btn-block"
          >VOLTAR</Botao
        >
      </div>
    </div>
  </div>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import ListaCarteira from "@/components/cadastro/ListaAssociados";
import Botao from "@/components/botoes/Botao";

export default {
  name: "Lista",
  components: { Titulo, ListaCarteira, Botao },
  data() {
    return {
      produto: {
        nome: "CDL Consultor",
        id: "cdlConsultor",
      },
      breadcrumb: [
        {
          nome: "CDL Consultor",
          id: "cdlConsultor",
          produto: "CDLConsultor",
        },
        {
          nome: "Gerenciar Associado",
          id: "gerenciarAssociado",
          produto: "CDLConsultor",
        },
      ],
      lista: [],
      loading: true,
    };
  },
  async created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.loading = false;
    localStorage.removeItem("spc_consultor");
    localStorage.removeItem("associadoSelecionado");

    await this.$http
      .get("/login/me")
      .then((response) => {
        this.$user = response.data;
        this.$store.commit("UPDATE_USER", response.data);
      })
      .catch((error) => {
        console.error(error);
      });

    if (this.$user.carteira !== "undefined") {
      this.lista = this.$user.carteira.associados;

      //var socioSel = this.lista.filter((el) => el.codSocio == "01086463");
      /*this.$http
        .get(
          `/api/Consultor/ConsultarChamados?codSocio=${socioSel[0].codSocio}`
        )
        .then((response) => {
          console.log(response);
        });*/
    }
    for (const [i, el] of this.lista.entries()) {
      var returnFluig = null;
      var reenvio = false;

      if (el.codSocio && el.chamadoDocumentacao) {
        await this.$http
          .get(`/api/Consultor/ConsultarChamados?codSocio=${el.codSocio}`)
          .then((response) => {
            if (response.data.length) {
              returnFluig = response.data[response.data.length - 1];

              if (
                returnFluig.comprovanteConselho &&
                returnFluig.comprovanteConselho
                  .split(/\W+/)
                  .includes("INCORRETA")
              ) {
                reenvio = true;
              }
              if (
                returnFluig.comprovanteEndereco &&
                returnFluig.comprovanteEndereco.includes("INCORRETA")
              ) {
                reenvio = true;
              }
              if (
                returnFluig.comprovanteReceidaFederal &&
                returnFluig.comprovanteReceidaFederal.includes("INCORRETA")
              ) {
                reenvio = true;
              }
              if (
                returnFluig.contratoSocial &&
                returnFluig.contratoSocial.includes("INCORRETA")
              ) {
                reenvio = true;
              }
              if (
                returnFluig.declaracaoTributacao &&
                returnFluig.declaracaoTributacao.includes("INCORRETA")
              ) {
                reenvio = true;
              }
              if (
                returnFluig.documentoIdentificacao &&
                returnFluig.documentoIdentificacao.includes("INCORRETA")
              ) {
                reenvio = true;
              }
              if (
                returnFluig.guiaInssPago &&
                returnFluig.guiaInssPago.includes("INCORRETA")
              ) {
                reenvio = true;
              }
              if (
                returnFluig.pisOuNid &&
                returnFluig.pisOuNid.includes("INCORRETA")
              ) {
                reenvio = true;
              }
            }
          });
      }

      if (!el.aceiteTermoUso) {
        this.lista[i].etapa = "Termo de Uso";
        this.lista[i].action = "Aguardando";
      } else if (!el.aceiteContrato && !el.codSocio) {
        this.lista[i].etapa = "Cadastro";
        this.lista[i].action = "Cadastrar";
        this.lista[i].color = "text-primary";
        this.lista[i].router = "cadastro";
      } else if ((el.codSocio && !el.chamadoDocumentacao) || reenvio) {
        this.lista[i].etapa = "Arquivos";
        this.lista[i].action = "Enviar Arquivos";
        this.lista[i].color = "text-primary";
        this.lista[i].router = "arquivos";
      } else {
        this.lista[i].etapa = "Ativo";
        this.lista[i].action = "Editar";
        this.lista[i].color = "text-success";
        this.lista[i].router = "painelAssociado";
      }
      if (!el.nomeSocio) {
        this.lista[i].nomeSocio = el.email;
        this.lista[i].codSocio = "-";
        this.lista[i].documento = "-";
      }
    }
  },
};
</script>
<style lang="scss" scoped>
@media screen and(max-width: 900px) {
  #v-pills-tab {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    margin-bottom: 1rem;
    a {
      width: 22%;
      text-align: center;
      justify-content: center;
      align-items: center;
      span {
        display: none;
      }
    }
  }
}
</style>
